module.exports = __webpack_public_path__ + "static/img/RO.755a3ebc.svg";